<template>
	<section id="projects">
		<div class="container">
			<h3>Projects</h3>
			<div class="features">
				<article>
					<div class="inner">
						<h4>Personal</h4>
						<ul>
							<li><a target="_blank" href="https://github.com/samweru/bible-an/releases/download/v1.0.0/bible-v1.apk"><span class="jquery">KJV Bible <b>[Android]</b></span></a></li>
							<li><a target="_blank" href="https://github.com/samweru-zz/blockly#blockly"><span class="jquery">Blockly <b>[PHP]</b></span></a> - How blockchain works!</li>
							<li><a target="_blank" href="#"><span class="jquery">Strukt App <b>[PHP]</b></span></a> - RAD</li>
						</ul>
						<!-- <br> -->
					</div>
				<!-- </article>
				<article> -->
					<div class="inner">
						<h4>Websites Portfolio</h4>
						<ul>
							<li><a target="_blank" href="https://samweru.github.io/project/callstreet"><span class="routr">Callstreet Ltd <b>[Vue]</b></span></a></li>
							<li><a target="_blank" href="https://samweru.github.io/project/kenaqua"><span class="routr">KenAqua Ltd <b>[Vue]</b></span></a></li>
							<li><a target="_blank" href="portfolio.html"><span class="routr">More..</span></a></li>
						</ul>
					</div>
				</article>
			</div>
		</div>
	</section>
</template>